import { Component, OnInit } from '@angular/core';
import { SettingsApiService } from 'src/app/services/settings.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import moment from 'moment';
import { ReferenceLibraryService } from 'reference-library';
@Component({
  selector: 'app-login-and-security',
  templateUrl: './login-and-security.component.html',
  styleUrls: ['./login-and-security.component.scss']
})
export class LoginAndSecurityComponent implements OnInit {

  public loggedInBeneficiaryId;
  public errorMessage: string;
  public userListing: Object[];
  public userListingResponseBkup;
  public editId;
  public usnmBlockOpen: boolean;
  public pwdBlockOpen: boolean;
  public commEmailBlockOpen: boolean;
  public loggeduserId;
  masterAccount;
  userTypeRole: string;
  constructor(private settingsApiService: SettingsApiService,
    private authenticationService: AuthenticationService,
    private referenceLibraryService: ReferenceLibraryService,
    private toastr: ToastrService,
    private router: Router) {
    this.usnmBlockOpen = false;
    this.pwdBlockOpen = false;
    this.commEmailBlockOpen = false;
    this.userListing = [];
    this.userListingResponseBkup = '';
    this.loggeduserId = '';
    this.userTypeRole = '';
  }

  ngOnInit() {
    this.userTypeRole = sessionStorage.getItem('userTypeRole');
    this.authenticationService.currentUser.subscribe((data) => {
      this.loggeduserId = data['userId'];
    });
    this.loggedInBeneficiaryId = parseInt(sessionStorage.getItem('loggedInBeneficiaryId'));
    if (this.loggedInBeneficiaryId > 0) {
      this.populatePage();
    }
  }

  ngAfterViewInit() {
    this.translet();
  }

  translet() {
    setTimeout(() => {
      this.referenceLibraryService.transletConversion();
    }, 600);
  }

  toggleView(type) {
    if (type == 'pwdBlock') {
      this.pwdBlockOpen = !this.pwdBlockOpen;
    }
    else if (type == 'usnmBlock') {
      this.usnmBlockOpen = !this.usnmBlockOpen;
    }
    else if (type == 'commEmailBlock') {
      this.commEmailBlockOpen = !this.commEmailBlockOpen;
    }
  }

  verifyPassword(item){
    this.authenticationService.loginCheck(item.username,item.password).subscribe((data) => {
      if(data.status == 200){
        //item.saveEnable = true;
        item.userNameEnabled = false;
        item.passwordEnabled = false;
        this.toastr.success("Account verified!", 'Success');
      }
    });
    this.translet();
  }

  formatDate(date) {
    return moment(date).format('DD-MMM-YYYY');
  }

  populatePage() {
    this.userListing = [];
    this.settingsApiService.getUserName(this.loggedInBeneficiaryId).subscribe((response: []) => {
      response.map((item) => {
        let userObj = {
          username: item['username'],
          companyName: item['companyName'],
          companyId: item['companyId'],
          lastUpdatedDate: item['lastUpdatedDate'],
          expiryDate: item['expiryDate'],
          isMasterAccount: item['isMasterAccount'],
          isPrimary: item['isPrimary'],
          loginId: item['loginId'],
          password :'',
          commEmail:item['communicationEmailId'],
          saveEnable : false,
          pwd_hide: false,
          userNameEnabled: true,
          passwordEnabled: true,
          newusername: ''
        }
        this.userListing.push(userObj);
      });
    },
      () => { },
      () => {
        ///positionign personal email at bottom of the list
        let idx = this.userListing.findIndex(item => item['isMasterAccount'] === 1);
        let itm = (this.userListing.splice(idx, 1)[0] || null);
        this.masterAccount = itm;
        itm != null ? this.userListing.push(itm) : '';
        this.userListingResponseBkup = JSON.stringify(this.userListing);
      });
  }

  setEditIndex(idx) {
    this.editId = idx;
    this.errorMessage = '';//reset validations message
    this.userListing = JSON.parse(this.userListingResponseBkup); //reflow form with original data
    this.translet();
  }

  saveUserName(userinfoItem) {
    this.errorMessage = '';
    let payload = {
      "loginId": userinfoItem.loginId,
      "username": userinfoItem.newusername
    }
    this.settingsApiService.saveUserName(this.loggedInBeneficiaryId, payload).subscribe((respose) => {
      if (respose.status === 200) {
        this.editId = null;
        this.errorMessage = '';
        this.toastr.success(respose.message, 'User name updated');
        userinfoItem['loginId'] == this.loggeduserId ? this.logout() : this.populatePage();
      }
      else {
        this.errorMessage = respose.message;
      }
    });
  }

  saveUserNamePersonal(masterAccount){
    //this.saveUserName(userinfoItem);
    let payload = {
      "loginId": masterAccount.loginId,
      "communicationEmailId": masterAccount.commEmail
    }
    this.settingsApiService.updateCommEmail(this.loggedInBeneficiaryId, payload).subscribe((respose) => {
      if (respose.status === 200) {
        this.toastr.success(respose.message, 'Success');
      }
    });
  }

  logout() {
    this.authenticationService.logout().subscribe(data => {
      if(data && data['status'] === 200){
        this.authenticationService.clearUserData();
        this.router.navigate(['/login']);
      }
   });
  }

  enableSaveButton(flag,item){
    if(flag)
      item.saveEnable = true;
    else
    item.saveEnable = false;
  }

}
